import React from 'react';
import LessonHome from '../LessonHome';

const Lesson12 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson12;